import {useMergeUnitsDm, useUnitDm} from "../../../../../__snowpack__/link/packages/dm/dist/dm.esm.js";
import {useTranslation} from "../../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialGrid from "../../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Button from "../../../../components/atoms/button/button.component.js";
import AlertDialog from "../../../../components/molecules/alert-dialog/alert-dialog.component.js";
import Breadcrumbs from "../../../../components/molecules/breadcrumbs/breadcrumbs.component.js";
import MergeSuggestionsList from "../../../../components/molecules/merge-suggestions-list/merge-suggestions-list.component.js";
import MergeUnitsEditPageSkeleton from "../../../../components/molecules/skeleton/merge-units-edit-page-skeleton/merge-units-edit-page-skeleton.component.js";
import MergeUnitFilterModule from "../../../../components/organisms/merge-unit-filter-module/merge-units-filter-module.component.js";
import MergeUnitsHistory from "../../../../components/organisms/merge-units-history/merge-units-history.components.js";
import MergeUnitsList from "../../../../components/organisms/merge-units-list/merge-units-list.component.js";
import MergeUnitsQueue from "../../../../components/organisms/merge-units-queue/merge-units-queue.component.js";
import {withReduxAndStyle} from "../../../../hoc/bridge.hoc.js";
import {useNavigateTo} from "../../../../hooks/use-navigate-to.js";
import {useParseFilters} from "../../../../hooks/use-parse-filters.hook.js";
import {usePropertiesFilters} from "../list/merge-units-list.hook.js";
import {MergeUnitsEditPageContainer, UnitListGridContainer} from "./merge-units-edit-page.styles.js";
import Pagination from "../../../../../__snowpack__/pkg/@mui/material/Pagination.js";
import Stack from "../../../../../__snowpack__/pkg/@mui/material/Stack.js";
import {makeStyles} from "../../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  paging_flex: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center"
  }
});
function MergeUnitsEditPage({
  jwt,
  property,
  filters,
  breadcrumbs,
  search
}) {
  const {
    getMergeUnitsDuplicatesList,
    getMergeUnitsHistory,
    createMergeUnit,
    revertMergeEvent
  } = useMergeUnitsDm(jwt);
  const {
    getUnitsList
  } = useUnitDm(jwt);
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [navigateDetail, setNavigateDetail] = useState();
  const [initialLoad, setInitialLoad] = useState(true);
  const [propertyUnitsSrc, setPropertyUnitsSrc] = useState([]);
  const [propertyUnitsDst, setPropertyUnitsDst] = useState([]);
  const [mergeSuggestions, setMergeSuggestions] = useState([]);
  const [mergeHistory, setMergeHistory] = useState([]);
  const [mergeQueue, setMergeQueue] = useState([]);
  const [total, setTotal] = useState(0);
  const filterFormRef = useRef(null);
  const [listFilters, setListFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [routeFiltersLoaded, setRouteFiltersLoaded] = useState(false);
  const {
    open,
    loading,
    accountList,
    propertyList,
    groupList,
    portfolioList,
    onOpenAutocomplete,
    onCloseAutocomplete,
    onRefetchField
  } = usePropertiesFilters(jwt, filterFormRef);
  const {
    routeFilters
  } = useParseFilters(listFilters, jwt, filters);
  const {
    navigateTo
  } = useNavigateTo();
  const [page, setPage] = React.useState(1);
  const loadMergeUnitsList = useCallback(async () => {
    setTimeout(() => {
      Promise.all([getUnitsList({
        property
      }), getUnitsList({
        property
      }), getMergeUnitsDuplicatesList(property), getMergeUnitsHistory(property, page)]).then(([unitsSrc, unitsDst, suggestions, history]) => {
        setPropertyUnitsSrc(unitsSrc.results);
        setPropertyUnitsDst(unitsDst.results);
        setMergeSuggestions(suggestions.results);
        setMergeHistory(history.results);
        setTotal(Math.ceil(history.count / 50));
        setInitialLoad((prevState) => prevState ? false : prevState);
      });
    }, 5e3);
  }, [getMergeUnitsDuplicatesList, getMergeUnitsHistory, getUnitsList, property]);
  const handlehistoryChange = (event, value) => {
    setPage(value);
    getMergeUnitsHistory(property, value).then((history) => {
      setMergeHistory(history.results);
      setTotal(Math.ceil(history.count / 50));
    });
  };
  const showDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);
  const fetchData = useCallback(async () => {
    await loadMergeUnitsList();
  }, [loadMergeUnitsList]);
  useEffect(() => {
    if (!propertyUnitsSrc.length && !propertyUnitsDst.length && !mergeSuggestions.length && !mergeHistory.length && initialLoad) {
      fetchData().catch((e) => console.error(e));
    }
  }, [fetchData, initialLoad, mergeHistory.length, mergeSuggestions.length, propertyUnitsDst.length, propertyUnitsSrc.length]);
  useEffect(() => {
    const changeLocationEventFn = (e) => {
      setNavigateDetail(e.detail);
      showDialog();
    };
    if (!initialLoad) {
      const element = document.querySelector("#merge-units-edit-page");
      if (element) {
        element.removeEventListener("changeLocation", changeLocationEventFn);
        element.addEventListener("changeLocation", changeLocationEventFn);
      }
    }
    return () => {
      const element = document.querySelector("#merge-units-edit-page");
      if (element) {
        element.removeEventListener("changeLocation", changeLocationEventFn);
      }
    };
  }, [initialLoad, showDialog]);
  useEffect(() => {
    window.pendingMerge = !!mergeQueue.length;
  }, [mergeQueue.length]);
  const filterEq = Object.keys(JSON.parse(JSON.stringify(filters))).length === Object.keys(routeFilters).length;
  useEffect(() => {
    if (Object.keys(listFilters).length === 0 && filterEq && !routeFiltersLoaded) {
      setListFilters(routeFilters);
      setRouteFiltersLoaded(true);
    }
  }, [filterEq, listFilters, routeFilters, routeFiltersLoaded]);
  const getUpdatedBreadcrumbs = useCallback(() => {
    const propertyName = listFilters?.property && {
      name: listFilters?.property[0].label
    };
    if (listFilters?.property && propertyName) {
      return [...breadcrumbs, {
        ...propertyName
      }];
    }
    return breadcrumbs;
  }, [breadcrumbs, listFilters]);
  const handleSearch = useCallback((term) => {
    const parsedFilters = Object.fromEntries(Object.entries(listFilters).map(([key, value]) => [key, value.map((v) => v.id)]));
    delete parsedFilters["property"];
    Object.assign(parsedFilters, {
      search: term
    });
    navigateTo({
      toState: "admin-utilities/merge-units",
      toParams: parsedFilters
    });
  }, [listFilters, navigateTo]);
  const handleCreateMerge = useCallback((mergeUnits) => {
    createMergeUnit(mergeUnits);
    if (mergeUnits.length === mergeQueue.length) {
      setMergeQueue([]);
    } else {
      setMergeQueue(mergeQueue.filter((l) => l !== mergeUnits[0]));
    }
    fetchData().catch((e) => console.error(e));
  }, [createMergeUnit, fetchData, mergeQueue]);
  const handleUnmerge = useCallback((mergeHistoryId) => {
    revertMergeEvent(mergeHistoryId);
    fetchData().catch((e) => console.error(e));
  }, [fetchData, revertMergeEvent]);
  const handleChange = useCallback((unit) => {
    setMergeQueue((prevState) => [...prevState, unit]);
  }, []);
  const handleQueue = useCallback((unit) => {
    setMergeQueue((prevState) => [...prevState, unit]);
  }, []);
  const handleQueueAll = useCallback((units) => {
    setMergeQueue((prevState) => [...prevState, ...units]);
  }, []);
  const handleRemoveQueue = useCallback((index) => {
    setMergeQueue((prevState) => [...prevState.slice(0, index), ...prevState.slice(index + 1)]);
  }, []);
  const handleClearQueue = useCallback(() => {
    setMergeQueue([]);
  }, []);
  const handleSearchSrc = useCallback((searchSrc) => {
    if (searchSrc) {
      getUnitsList({
        property,
        search: searchSrc
      }).then((response) => {
        setPropertyUnitsSrc(response.results);
      });
    } else {
      getUnitsList({
        property
      }).then((response) => {
        setPropertyUnitsSrc(response.results);
      });
    }
  }, [getUnitsList, property]);
  const handleSearchDst = useCallback((searchDst) => {
    if (searchDst) {
      getUnitsList({
        property,
        search: searchDst
      }).then((response) => {
        setPropertyUnitsDst(response.results);
      });
    } else {
      getUnitsList({
        property
      }).then((response) => {
        setPropertyUnitsDst(response.results);
      });
    }
  }, [getUnitsList, property]);
  const handleAccept = useCallback(() => {
    window.pendingMerge = false;
    setDialogOpen(false);
    if (navigateDetail) {
      navigateTo(navigateDetail);
    }
  }, [navigateDetail, navigateTo]);
  const handleCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);
  const convertFilters = useCallback((filter) => {
    const newFilters = Object.fromEntries(Object.entries(typeof filter === "object" ? filter : listFilters).filter(([key]) => typeof filter === "object" || key !== filter).map(([key, value]) => [key, value.map((v) => v.id)]));
    navigateTo({
      toState: "admin-utilities/merge-units",
      toParams: newFilters
    });
  }, [listFilters, navigateTo]);
  const handleSubmitFilters = useCallback((values) => {
    setOpenFilter(false);
    convertFilters(values);
  }, [convertFilters]);
  const handleResetFilters = useCallback(() => {
    filterFormRef.current?.setValues({
      account: [],
      portfolio: [],
      group: [],
      property: []
    });
  }, []);
  if (initialLoad) {
    return /* @__PURE__ */ React.createElement(MergeUnitsEditPageSkeleton, null);
  }
  return /* @__PURE__ */ React.createElement(MergeUnitsEditPageContainer, {
    id: "merge-units-edit-page"
  }, /* @__PURE__ */ React.createElement(Breadcrumbs, {
    breadcrumbs: getUpdatedBreadcrumbs()
  }), /* @__PURE__ */ React.createElement(MergeUnitFilterModule, {
    innerRef: filterFormRef,
    initialValues: listFilters,
    listFilters,
    onSubmit: handleSubmitFilters,
    onReset: handleResetFilters,
    drawerOpen: openFilter,
    onClose: () => setOpenFilter(false),
    onOpenDrawer: () => setOpenFilter(true),
    open,
    loading,
    accountList: accountList || [],
    portfolioList: portfolioList || [],
    groupList: groupList || [],
    propertyList: propertyList || [],
    onOpenAutocomplete,
    onCloseAutocomplete,
    onRefetchField,
    term: search,
    onSearch: handleSearch,
    onRemoveFilter: convertFilters
  }), /* @__PURE__ */ React.createElement(MaterialGrid, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ React.createElement(UnitListGridContainer, {
    container: true,
    item: true,
    xs: 12,
    spacing: 2,
    display: "grid",
    gridAutoFlow: "column"
  }, /* @__PURE__ */ React.createElement(MergeUnitsList, {
    dataDst: propertyUnitsDst,
    dataSrc: propertyUnitsSrc,
    onChange: handleChange,
    onSearchSrc: handleSearchSrc,
    onSearchDst: handleSearchDst,
    mergeQueue
  }), /* @__PURE__ */ React.createElement(MergeSuggestionsList, {
    pairs: mergeSuggestions,
    mergeQueue,
    onQueue: handleQueue,
    onQueueAll: handleQueueAll
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(MergeUnitsQueue, {
    mergeQueue,
    onMerge: handleCreateMerge,
    onRemoveFromQueue: handleRemoveQueue,
    onClearQueue: handleClearQueue
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(MergeUnitsHistory, {
    mergeHistory,
    onUnmerge: handleUnmerge
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, mergeHistory.length > 0 && total > 1 && /* @__PURE__ */ React.createElement(Stack, {
    className: classes.paging_flex,
    spacing: 2
  }, /* @__PURE__ */ React.createElement(Pagination, {
    count: total,
    showFirstButton: true,
    showLastButton: true,
    page,
    siblingCount: total,
    onChange: handlehistoryChange,
    variant: "outlined",
    shape: "rounded"
  })))), dialogOpen && /* @__PURE__ */ React.createElement(AlertDialog, {
    open: dialogOpen,
    onClose: handleCancel,
    title: t("units.mergeLeaveWarningTitle"),
    showCloseIcon: true,
    content: /* @__PURE__ */ React.createElement(MaterialBox, {
      height: 300
    }, /* @__PURE__ */ React.createElement(MaterialTypography, {
      variant: "body1"
    }, t("units.mergeLeaveWarning"))),
    actions: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
      onClick: handleCancel,
      variant: "text",
      translate: "actions.close"
    }), /* @__PURE__ */ React.createElement(Button, {
      onClick: handleAccept,
      variant: "text",
      translate: "units.mergeExit"
    }))
  }));
}
export default /* @__PURE__ */ React.memo(withReduxAndStyle(MergeUnitsEditPage));
